module.exports = __webpack_public_path__ + "img/team14.ff0d03e0.jpg";